import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PickList from '../PickList';
import DatePicker from '../DatePicker';
import CustomTimePicker from '../CustomTimePicker';
import { row, column } from '../../globals';

const VisitInformationStyled = styled.div`
    background: white;
    padding: 0 10px;
`;

const TitleStyled = styled.div`
    padding: 60px 0 5px 20px;
    font-size: 25px;
    color: #3E2723;
    letter-spacing: 0;
    font-family: IntroRegular;
`;

const Row = styled.div`
  ${row(0)};
`;

const StyledField = styled.div`
    ${column(12, 'xs')};
    ${column(6, 'md', 20)};
`;

class VisitInformation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            date: props.date,
            time: props.time,
            diningType: props.diningType
        };
    }

    updateVisitInfo = (val) => {
        this.setState(val, this.props.updateVisitInfo(val));
    };

    render() {
        return (
            <VisitInformationStyled>
                <TitleStyled>
                    {this.props.getLocalizedText('VisitInformation', 'Visit Information')}
                </TitleStyled>
                <Row>
                    <StyledField>
                        <DatePicker placeholderText={this.props.getLocalizedText('DateOfVisit', 'Date of Visit (MM/DD/YYYY)')}
                                    selectedDay={this.state.date}
                                    handleDayChange={ (val) => {
                                        const errors = this.props.errors;
                                        errors.date = false;
                                        this.updateVisitInfo({ date: val, errors });
                                    }}
                                    error={this.props.errors.date}
                                    getLocalizedText={this.props.getLocalizedText} />
                    </StyledField>
                    <StyledField>
                        <CustomTimePicker value={this.state.time}
                                          handleTimeChange={ (val) => {
                                              this.updateVisitInfo({ time: val });
                                          }}
                                          getLocalizedText={this.props.getLocalizedText} />
                    </StyledField>
                </Row>
                <Row>
                    <StyledField>
                        <PickList instanceId={'dine'}
                                  label={this.props.getLocalizedText('HowDidYouDineWithUs', 'How did you dine with us?')}
                                  options={ this.props.diningOptions }
                                  value={this.state.diningType}
                                  handleChange={(val) => {
                                      const errors = this.props.errors;
                                      errors.diningType = false;
                                      this.updateVisitInfo({ diningType: val, errors });
                                  }}
                                  error={this.props.errors.diningType}
                                  getLocalizedText={this.props.getLocalizedText} />
                    </StyledField>
                </Row>
            </VisitInformationStyled>
        );
    }

}

VisitInformation.propTypes = {
    date: PropTypes.string,
    time: PropTypes.string,
    diningType: PropTypes.string,
    diningOptions: PropTypes.array,
    updateVisitInfo: PropTypes.func.isRequired,
    getLocalizedText: PropTypes.func.isRequired,
    errors: PropTypes.object,
    locale: PropTypes.shape({
        country: PropTypes.string,
        language: PropTypes.string,
        localeCode: PropTypes.string
    })
};

VisitInformation.defaultProps = {
    date: '',
    time: '',
    diningType: '',
    diningOptions: [],
    updateVisitInfo: () => {},
    getLocalizedText: (key, defaultValue) => defaultValue,
    errors: {},
    locale: {
        country: 'US',
        language: 'en',
        localeCode: 'en_US'
    }
};

export default VisitInformation;



// WEBPACK FOOTER //
// ./src/components/VisitInformation/index.js